import { useGlobalState } from '../App/globalState';
import { isUserSessionActive } from '../Helpers/user-session-expiration';

export default function useIsLoggedIn() {
  const { globalState } = useGlobalState();

  const isLoggedIn = !!globalState?.user?.id;
  const isActive = isUserSessionActive(globalState?.user?.ses_exp);

  return isLoggedIn && isActive;
}
